module.exports = __webpack_public_path__ + "static/img/1996_phase_function_Paper_PointsHejduk_Prediction.32912bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1996_phase_function_Paper_PointsHejduk_Prediction.png
// module id = aYZu
// module chunks = 0